import { connect } from 'react-redux';
import { showRevenueModal, showPromoAnalysisModal } from '../../redux/actions/modals';
import BaseRevenueView from '../revenue/BaseRevenueView';
import { revenueViewTypes, revenueVarianceTypes, revenueGraphOptions } from '../../helpers/revenue';
import revenue from '../../api/revenue';
import collections from '../../api/collections';

class RevenueView extends BaseRevenueView {

  useGroupBy = true;
  viewTypes = revenueViewTypes;
  isVariance = false;

  handleRefresh = () => {
    const { selectedOperator, selectedWeek, selectedVarianceType, selectedCategory, selectedGroupBy, selectedRegion } = this.state
    this.setState({ activeRow: { optionShowDetails: false }, graph: { lines: [], data: [] }, loading: true }, () => {
      revenue.getSummary(selectedOperator, selectedWeek, selectedCategory, selectedVarianceType, selectedGroupBy, selectedRegion).then(
        summary => this.setState({ summary, loading: false }),
        () => this.setState({ loading: false })
      );
    })
  }

  onDetailsClick = () => {
    const { selectedViewType, activeRow, selectedOperator } = this.state;
    if (selectedViewType !== 4) {
      this.props.showRevenueModal(activeRow, selectedOperator, this.isVariance, () => this.handleRefresh());
    } else {
      this.setState({ detailsLoading: true }, () => {
        collections.getPeriods(selectedOperator, activeRow.siteId).then(
          periods => {
            const selectedPeriod = periods[0].value;
            collections.getPromoCashDetails(selectedPeriod, activeRow.siteId).then(grid => this.props.showPromoAnalysisModal(periods, selectedPeriod, grid).then(() => this.setState({ detailsLoading: false })))
          }
        );
      })

    }
  }

  refreshGraph = () => {
    const { selectedWeek, selectedCategory, selectedGroupBy, selectedRegion, selectedViewType, selectedVarianceType, activeRow } = this.state;
    this.setState({ chartLoading: true }, () => {
      revenue.getGraph(activeRow.siteId, selectedWeek, selectedCategory, selectedViewType, selectedVarianceType, selectedGroupBy, selectedRegion).then(
        graph => this.setState({ graph, chartLoading: false }),
        () => this.setState({ chartLoading: false })
      );
    })
  }
}
const mapStateToProps = (state, ownProps) => {
	return {
    operators: state.operators.filter(x => x.value !== -1)
  }
}

export default connect(mapStateToProps, { showRevenueModal, showPromoAnalysisModal })(RevenueView);